import { AJOUTE_SOCIETE, SUPRIMER_SOCIETE } from '../types/typeSociete';

export const AjouteSociete = (societe) => {
    return {
        type: AJOUTE_SOCIETE,
        payload: societe
    }
}

export const suprimerSociete = (societe) => {
    return {
        type: SUPRIMER_SOCIETE,
        payload: societe
    }
}